import api from '../../helpers/axios'

export const state = {
    contract: null,
    contracts: []
};

export const getters = {
    contract: (state) => state.contract,
    contracts: (state) => state.contracts
};

export const mutations = {
    setContract(state, newValue) {
        state.contract = newValue;
    },
    setContracts(state, newValue) {
        state.contracts = newValue;
    },
};

export const actions = {
    createContract(_,  data) {
        return new Promise((resolve, reject) => {
            api.post("/contracts", data).then((res) => {
                if(res){
                    resolve(res.data.data)
                }
            }).catch((err) => {
                reject(err)
            })
        });
    },
    updateContract(_, {id,data}) {
        return new Promise((resolve,reject) => {
            api.put("/contracts/"+id, data).then((res) => {
                if(res){
                    resolve(res.data.data)
                }
            }).catch((err) => {
                reject(err)
            })
        });
    },
    deleteContract(_, id) {
        return new Promise((resolve) => {
            api.delete("/contracts/"+id).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    fetchContract({ commit }, {id}) {
        return new Promise((resolve,reject) => {
            api.get("/contracts/"+id).then((res) => {
                commit("setContract", res.data.data);
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },
    fetchContracts({ commit }, {page, limit, ...params}) {
        let query = "?";
        query += `page=${page}&`;
        query += `limit=${limit}`;
        return new Promise((resolve) => {
            api.get("/contracts"+query,{params}).then((res) => {
                commit("setContracts", res.data.data);
                resolve(res.data.data)
            })
        });
    }
};
